import { faChevronUp } from '@fortawesome/pro-regular-svg-icons/faChevronUp';
import React from 'react';
import styled from 'styled-components';
import THEME, { COLOR } from '../../styles/colors';
import Font from '../../styles/font';
import Icon from '../Icon/Icon';
import StyledText from '../Text/StyledText';

const StyledDropdownButton = styled.button`
  color: ${THEME.text.secondary};
  background-color: ${THEME.surface.primary};
  :hover {
    background-color: ${THEME.surface.tertiary};
  }

  padding: 8px 12px;

  border: 1px solid ${THEME.general.border};
  border-radius: 8px;

  display: flex;
  align-items: center;
  justify-content: space-between;
  white-space: nowrap;

  cursor: pointer;
  appearance: none;
`;

interface IDropdownButtonProps {
  text: string;
  badgeText?: string;
  as?: string;
}

const DropdownButton: React.FC<IDropdownButtonProps> = ({
  text,
  badgeText,
  ...rest
}) => {
  const typeProps: any =
    typeof rest.as === 'undefined' || rest.as === 'button'
      ? { type: 'button' }
      : {};

  return (
    <StyledDropdownButton {...typeProps} {...rest} className={Font.f12_tall}>
      {text}
      {badgeText && (
        <StyledText className={Font.f12_bold_tall} $marginLeft="4px">
          {badgeText}
        </StyledText>
      )}
      <Icon
        icon={faChevronUp}
        rotation={180}
        color={COLOR.neutral60}
        $marginLeft="4px"
      />
    </StyledDropdownButton>
  );
};

export default DropdownButton;
